// extracted by mini-css-extract-plugin
export default {"spacer":"spacer___W2hL0","custom_spacer":"custom_spacer___vyUqF"};